import styled from 'styled-components';
import { zIndex } from '@morressier/ts';
import { FaRegTimesCircle } from 'react-icons/fa';

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectButton = styled.button<{
  hasValue: boolean;
  hasError: boolean;
}>`
display: flex;
justify-content: space-between;
align-items: center;

font-size: var(--fontSizes-normal);
line-height: var(--lineHeights-normal);

border: 1px solid ${({ hasError }) =>
  hasError ? 'var(var(--color-red-50))' : 'var(--color-mono-60)'};
padding: 8px;
width: 100%;
background-color: var(--color-mono-100);
border-radius: 4px;
color: ${({ hasValue }) =>
  hasValue ? 'var(--color-mono-0)' : 'var(--color-mono-60)'};
&:hover, &:focus-within {
  border 1px solid ${({ hasError }) =>
    hasError ? 'var(var(--color-red-50))' : 'var(--color-mono-0)'};
  svg {
    color: var(--color-mono-0);
  }
}
svg {
  color: var(--color-mono-60);
  margin-left: auto;
}
`;

export const List = styled.ul<{ isOpen: boolean }>`
  position: absolute;
  z-index: ${zIndex('modal')};
  width: 100%;

  overflow-y: scroll;
  background-color: var(--color-mono-100);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  max-height: 220px;
  padding: 8px 0px;
  transition: display ease-in-out 0.3s;
  > li:not(:last-child) {
    border-bottom: 1px solid var(--color-mono-95);
  }
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  &:focus {
    border: 1px solid red;
  }
`;

export const ListItem = styled.li`
  padding: 0.5rem 1rem;
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: var(--color-mono-99);
  }
  &:focus {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;

export const ClearIcon = styled(FaRegTimesCircle)`
  font-size: 1rem;
`;
